import { ReactNode } from "react";
import { Card } from "@/components/ui/card";

interface DashboardWidgetProps {
  children: ReactNode;
  className?: string;
}

export const DashboardWidget = ({ children, className = "" }: DashboardWidgetProps) => {
  return (
    <Card className={`p-4 h-full overflow-auto ${className}`}>
      {children}
    </Card>
  );
};
